import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './ImageWrapper.module.scss';

const propTypes = {
  overlay: PropTypes.bool,
  zoomHover: PropTypes.bool,
  children: PropTypes.node,
};

const ImageWrapper = ({ overlay = false, zoomHover = false, children = <></> }) => {
  return (
    <div className={cx(overlay ? s.overlay : '', zoomHover ? s.zoomHover : '')}>{children}</div>
  );
};

ImageWrapper.propTypes = propTypes;
export default ImageWrapper;
